/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { InvoiceDataSource } from '../enums/invoice-data-source.enum';
import { InvoiceDataError } from '../enums/invoice-data-error.enum';
import { ActorDto } from '../../models/actor-dto';
import { InvoiceDataRowDto } from './invoice-data-row-dto';
import { InvoiceDataLogDto } from './invoice-data-log-dto';

export class InvoiceDataDto {
  public id: string = undefined;
  public source: InvoiceDataSource;
  public orderNumber: string = undefined;
  public formattedOrderNumber: string = undefined;
  public formattedCustomerNumber: string = undefined;
  public customerNumber: number = undefined;
  public customerName: string = undefined;
  public invoicingAddress: string = undefined;
  public customerContact: string = undefined;
  public readDate: Date | string;
  public sender: string = undefined;
  public receiver: string = undefined;
  public carRegistrationNumber: string = undefined;
  public invoiceNumber: string = undefined;
  public referenceNumber: string = undefined;
  public declarationDate: Date | string;
  public sequenceNumber: number = undefined;
  public expeditionAndSerialNumber: string = undefined;
  public swedishCustomsId: string = undefined;
  public mrn: string = undefined;
  public isModifiable: boolean;
  public canceled: boolean;
  public invoiceId: string = undefined;
  public errors: InvoiceDataError;
  public ecomCustomer: ActorDto;
  public ecomCaseId: string = undefined;
  public ecomClearanceCaseId: string = undefined;
  public ecomCaseDocumentId: string = undefined;
  public rows: InvoiceDataRowDto[];
  public changeLog: InvoiceDataLogDto[];

  //<custom-body>
  public overviewErrorTextAndTooltip: { text: string; tooltip: string }[];
  constructor(source: InvoiceDataDto) {
    Object.assign(this, source);
    this.ecomCustomer = source.ecomCustomer
      ? new ActorDto(source.ecomCustomer)
      : null;
    this.mrn = this.mrn || this.mrn;
    this.overviewErrorTextAndTooltip = this.getOverviewErrorTextAndTooltip();
  }

  public get needsEcomCustomer(): boolean {
    return +this.source === InvoiceDataSource.ExternalApi && !this.ecomCustomer;
  }

  public getOverviewErrorTextAndTooltip(): { text: string; tooltip: string }[] {
    const result: { text: string; tooltip: string }[] = [];
    if (this.errors & InvoiceDataError.ArticleMissing)
      result.push({
        text: 'financials.proteria.overview.errors.articlemissing',
        tooltip: 'financials.proteria.errors.articlemissing'
      });
    if (this.errors & InvoiceDataError.ArticleQuantity)
      result.push({
        text: 'financials.proteria.overview.errors.articlequantity',
        tooltip: 'financials.proteria.errors.articlequantity'
      });
    if (this.errors & InvoiceDataError.MissingConnection)
      result.push({
        text: 'financials.proteria.overview.errors.missingconnection',
        tooltip: null
      });
    if (this.errors & InvoiceDataError.MissingPrice)
      result.push({
        text: 'financials.proteria.overview.errors.missingprice',
        tooltip: 'financials.proteria.errors.pricemissing'
      });
    if (this.errors & InvoiceDataError.WaitingForService)
      result.push({
        text: 'financials.proteria.overview.errors.waitingforservice',
        tooltip: 'financials.proteria.errors.waitingforservice'
      });
    if (this.errors & InvoiceDataError.RequiresReview)
      result.push({
        text: 'financials.proteria.overview.errors.requiresreview',
        tooltip: 'financials.proteria.errors.requiresreview'
      });
    if (this.errors & InvoiceDataError.MultipleOrNoSource)
      result.push({
        text: 'financials.proteria.overview.errors.multipleornosource',
        tooltip: 'financials.proteria.errors.multipleornosource'
      });
    if (this.errors & InvoiceDataError.DuplicateMRN)
      result.push({
        text: 'financials.proteria.overview.errors.duplicatemrn',
        tooltip: 'financials.proteria.errors.duplicatemrn'
      });

    return result;
  }
  //</custom-body>
}
